import { useEffect, useState } from "react";
import { Bell, CheckCircle2 } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../components/ui/popover";
import api from "../lib/api";
import { toast } from "sonner";

export function NotificationBell() {
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/alerts?resuelto=false").then((r) => setAlerts(r.data));

  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  const resolver = async (id) => {
    await api.patch(`/alerts/${id}/resolver`);
    toast.success("Alerta marcada como resuelta");
    load();
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell-button" className="relative flex items-center justify-center h-9 w-9 rounded-full border border-border hover:bg-secondary transition-colors">
          <Bell className="h-4 w-4" strokeWidth={1.5} />
          {alerts.length > 0 && (
            <span data-testid="notification-bell-count" className="absolute -top-1 -right-1 h-4 min-w-[16px] px-1 rounded-full bg-accent-alert text-white text-[9px] font-bold flex items-center justify-center">
              {alerts.length}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notification-bell-panel">
        <div className="px-4 py-3 border-b border-border">
          <p className="text-xs uppercase tracking-widest font-bold text-muted-foreground">Alertas activas</p>
        </div>
        <div className="max-h-80 overflow-y-auto">
          {alerts.length === 0 && <p className="p-4 text-sm text-muted-foreground">Sin alertas pendientes.</p>}
          {alerts.map((a) => (
            <div key={a._id} className="px-4 py-3 border-b border-border last:border-0 flex items-start gap-2" data-testid={`alert-item-${a._id}`}>
              <span className={`h-1.5 w-1.5 rounded-full mt-1.5 shrink-0 ${a.nivel === "critical" ? "bg-accent-alert" : a.nivel === "info" ? "bg-[#0A84FF]" : "bg-accent-warning"}`} />
              <div className="flex-1">
                <p className="text-xs leading-relaxed">{a.mensaje}</p>
              </div>
              <button onClick={() => resolver(a._id)} data-testid={`resolve-alert-${a._id}`} title="Marcar resuelta">
                <CheckCircle2 className="h-4 w-4 text-muted-foreground hover:text-valoriza-leaf" />
              </button>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
